import type { UserValidationProperties } from '@/core/features/user/user-validation-type';

export const getGuestResponse = (): UserValidationProperties => ({
    isPointsUser: false,
    loginStatus: 'guest',
    updatedTimestamp: Date.now(),
    username: null,
});
